export const GET_SERVICE_LIST = "GET_SERVICE_LIST";